export default "__VITE_ASSET__YyB3YSet__"